import type { FC } from 'react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LinkStyled } from '@components/atoms/link/styles';
import type { LinkProps } from '@components/atoms/link/types';
import { styled } from '@mui/material/styles';
import cn from 'classnames';

const Atom: FC<LinkProps> = ({ href, to, dashed, inheritFont, className, ...rest }) => {
    const classNames = cn({ dashed, 'inherit-font': inheritFont }, className);

    if (to) {
        return <LinkStyled as={RouterLink} className={classNames} to={to} {...rest} />;
    }

    if (href) {
        return <LinkStyled href={href} className={classNames} {...rest} />;
    }

    return <LinkStyled className={classNames} {...rest} />;
};

export const Link = styled(Atom)({});
